<template>
<div class="customers">
    <h1 class="subheading grey--text">Customers</h1>
        <v-container class="my-5">

            <v-layout row wrap>
                <v-flex xs12 sm6 md4 lg3 v-for="customer in customers" :key="customer.stripe_id">
                    <v-card flat class="text-xs-center ma-3">
                        <v-responsive class="pt-4">
                            <v-avatar size="100" class="grey lighten-2">
                                <span class="white--text display-1 font-weight-black">{{getLetter(customer.first)}}</span> 
                            </v-avatar>
                        </v-responsive>
                        <v-card-text>                        
                            <div class="subheading">{{customer.first}} {{customer.last}}</div>
                            <div class="grey--text">{{customer.description}}</div>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn @click="editCustomer(customer.id)" flat right color="grey">
                                <v-icon small left>create</v-icon>
                                <span>edit</span>
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-flex>
            </v-layout>

        </v-container>
          <v-layout row justify-center>

    <v-dialog v-model="dialog" persistent max-width="600px">

      <v-card>
        <v-card-title>
          <span class="headline">Edit Customer Profile</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm6 md6>
                <v-text-field 
                    label="First name*" 
                    v-model="first"
                    required>
                </v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-text-field
                  label="Last name*"
                  v-model="last"
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field 
                    label="Email*" 
                    v-model="email"
                    required>
                </v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field 
                hint="e.g. Tryrell Corp, Industries"
                persistent-hint
                v-model="description"
                label="Company or entity name" 
                
                required>
                </v-text-field>
              </v-flex>

            </v-layout>
          </v-container>
          <small>*indicates required field</small>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click="dialog = false">Close</v-btn>
          <v-btn color="blue darken-1" flat @click="saveChanges(id)">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>

</div>




</template>

<script>

// TODO: activator for dialog button?
// TOOD: look info form autocomplete arrays for invoicing 

import firebase from 'firebase'
import db from '@/fb'

export default {
    data() {
        return {
            first: '',
            last: '',
            email: '',
            description: '',
            stripe_id: '',
            id: '',
            customers: [],
            dialog: false
        }
    },
    methods: {
        getLetter(name) {
            return (name.substring(0,1).toUpperCase())
        },
        editCustomer(id) {
            console.log("edit customer")
            let customer = db.collection('customers').doc(id).get()
            .then(doc =>{
                
                this.first= doc.data().first
                this.last= doc.data().last
                this.email= doc.data().email
                this.description= doc.data().description
                this.stripe_id= doc.data().stripe_id
                this.id= doc.id
            })
            .catch(err => console.log(err))
            this.dialog =true
        },
        saveChanges(id) {
            //clearTextFields()
            //TODO: clear fields on close (not save)
            
            let updateStripeData = {}
            this.customers.forEach(customer => {
                if (customer.id == id) { 
                    if (customer.email != this.email || customer.description != this.description) updateStripeData = {email: this.email, stripe_id: customer.stripe_id, description: this.description}
                    customer.first = this.first
                    customer.last = this.last
                    customer.email = this.email
                    customer.description = this.description
                }
            })
            
            if (updateStripeData.email != null) {
                // TODO: check error handling
                // TODO: add snackbar to confirm update
                // TODO: Validate form
                console.log ("need to update stripe email or description: ", updateStripeData.email)
                let updateCustomer = firebase.functions().httpsCallable('updateCustomer')
                updateCustomer(updateStripeData)
                .then(result => {
                    console.log("Stripe response: ", result)
                })
            } else {
                console.log ("didn't need to update stripe")
            }

            db.collection('customers').doc(this.id).set ({
                first: this.first,
                last: this.last,
                email: this.email,
                description: this.description,
                stripe_id: this.stripe_id
            }).then(() => console.log("updated customer in DB"))
            

            this.dialog = false
        },
        clearTextFields() {
            this.first= ''
            this.last= ''
            this.email= ''
            this.description= ''
            this.stripe_id= ''
            this.id= ''
        }
    },
    created() {
        db.collection('customers').onSnapshot(snapshot =>{
            let changes = snapshot.docChanges()
            changes.forEach(change =>{
                if (change.type=='added') {
                    this.customers.push({
                        ...change.doc.data(),
                        id: change.doc.id
                    })
                    // console.log(change.doc.data())
                }
            })
        })
    }
}
</script>
